import React from "react";
import { Box } from "@mui/material";
import Img3 from "../../assets/images/dashboard/img3.jpg";
import Contact from "../../assets/images/dashboard/page3/page3.png";
import Readmore from "../../assets/images/dashboard/page3/readmore.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Page3 = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${Img3})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "end",
        justifyContent: "flex-start",
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", md: "35%" },
          marginBottom: { xs: "160px", md: "50px" },
          marginLeft: { xs: "40px", md: "90px" },
          position: "relative",
        }}
      >
        <img
          style={{
            height: "auto",
            width: "100%",
            marginTop: "30px",
          }}
          src={Contact}
          alt="Contact"
        />
        <Box
          onClick={() => navigate("../../contactme")}
          sx={{
            position: "absolute",
            cursor: "pointer",
            bottom: { xs: 25, md: 45 },
            marginLeft: { xs: "10px", md: "20px" },
          }}
        >
          <img
            style={{
              height: "auto",
              width: isTablet ? "50%" : "35%",
              marginTop: "30px",
            }}
            src={Readmore}
            alt="Readmore"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Page3;
